import React from 'react';
import { reduxForm } from 'redux-form';

import collectionChangeHandler from '../../helpers/collection-change-handler';

import DatePicker from '../forms/datepicker';

import WorkOrderTimeFields from './work-order-time-fields';
import moment from 'moment';

import LocationSelectorContainer from '../../containers/forms/location-selector-container';

import ModalScrollTop from '../helpers/ModalScrollTop';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import cx from 'classnames';

import { generateValidation } from 'redux-form-validation';
import BaseModal from '../base-modal';
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock,
  CheckboxGroup,
  InlineCheckbox
} from '../modal-form/modal-form';

const constraints = {
  width: '706px',
  minWidth: '706px'
};

const validations = {
  locationId: {
    required: true
  },
  contact: {
    required: true
  },
  startsAt: {
    required: true
  },
  endsAt: {
    required: true
  },
  contactPhone: {},
  technicianIds: {},
  description: {},
  autoRenew: {},
  autoRenewInterval: {},
  autoRenewEndDate: {},
  showInputted: {}
};

class WorkOrdersCreateEdit extends React.Component {
  state = {
    canShowInputted: this.props.canShowInputted || false
  }

  render() {
    const {
      fields: {
        locationId,
        contact,
        contactPhone,
        startsAt,
        endsAt,
        startTime,
        duration,
        technicianIds,
        description,
        autoRenew,
        autoRenewInterval,
        autoRenewEndDate,
        showInputted
      },
      loading,
      locations,
      technicians,
      error,
      submitting,
      handleSubmit,
      handleClose,
      modalTitle,
      useAllLocations,
      showAutoRenew,
      backlog,
      submitButtonText,
      getLocationContact,
      getLocationContactPhone,
      getLocationDefaultWorkOrderDescription,
      getLocationCanShowInputted,

      fetchTechniciansForLocationWithAllocation,
      fetchContractsForLocation,
      getLocationContracts
    } = this.props;

    if (loading) return <p>Loading...</p>;

    const contracts = getLocationContracts(locationId.value);
    const activeContracts = contracts
      ? contracts.filter(({ startDate, endDate }) =>
          startsAt.value.isBetween(startDate, endDate)
        )
      : null;
    const showContractNotice =
      !!locationId.value && activeContracts && activeContracts.length === 0;

    return (
      <BaseModal
        onClose={handleClose}
        title={modalTitle}
        constraints={constraints}
        contentClassName="work-orders-create-container"
      >
        <a id="top" />
        <ModalForm
          onSubmit={handleSubmit}
          customClassName="work-orders-create-form"
        >
          <ModalFormRow>
            <ModalFormBlock>
              {
                <p
                  className={cx({
                    centered: true,
                    error: true,
                    hidden: !error || submitting
                  })}
                >
                  {error && error.detail}
                </p>
              }
              {
                <p
                  className={cx({
                    centered: true,
                    notice: true,
                    hidden: !showContractNotice
                  })}
                >
                  Please note there are no active contracts for this location at
                  the selected start date. Contact your account administrator.
                </p>
              }
            </ModalFormBlock>
          </ModalFormRow>
          <ModalFormRow>
            <ModalFormBlock>
              <label htmlFor="location">
                location <span style={{ color: 'red' }}>*</span>
              </label>

              <LocationSelectorContainer
                {...locationId}
                useAllLocations={useAllLocations==null?0:useAllLocations}
                onChange={(id, ...rest) => {
                  contact.onChange(getLocationContact(id));
                  contactPhone.onChange(getLocationContactPhone(id));
                  description.onChange(
                    getLocationDefaultWorkOrderDescription(id)
                  );

                  const canShowInputted = getLocationCanShowInputted(id);
                  showInputted.onChange(canShowInputted);
                  this.setState({ canShowInputted });

                  locationId.onChange(id, ...rest);
                  fetchTechniciansForLocationWithAllocation(id, {
                    startsAt: startsAt.value,
                    endsAt: endsAt.value
                  });
                  fetchContractsForLocation(id);
                }}
              />
            </ModalFormBlock>
          </ModalFormRow>
          <ModalFormRow>
            <ModalFormBlock>
              <label htmlFor="contact">contact</label>

              <div>
                <input
                  id="contact"
                  type="text"
                  placeholder="Type name"
                  {...contact}
                />
                <input
                  id="contact-phone"
                  type="tel"
                  placeholder="Type phone number"
                  {...contactPhone}
                />

                {contact.error && (
                  <div>
                    <p className="error">Cannot leave contact field blank.</p>
                    <ModalScrollTop />
                  </div>
                )}
              </div>
            </ModalFormBlock>
          </ModalFormRow>
          <WorkOrderTimeFields
            {...{
              startsAt: {
                ...startsAt,
                onChange: (start, end) => {
                  fetchTechniciansForLocationWithAllocation(locationId.value, {
                    startsAt: start,
                    endsAt: end
                  });
                  startsAt.onChange(start);
                },
                disabled: !locationId.value
              },
              endsAt: {
                ...endsAt,
                onChange: (start, end) => {
                  fetchTechniciansForLocationWithAllocation(locationId.value, {
                    startsAt: start,
                    endsAt: end
                  });
                  endsAt.onChange(end);
                },
                disabled: !locationId.value
              }
            }}
          />
          {!backlog && (
            <ModalFormRow>
              <CheckboxGroup title="technicians">
                <ReactCSSTransitionGroup
                  transitionName="workOrderTechs"
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={50}
                >
                  {Object.keys(technicians).map((tech, index) => {
                    return (
                      <label
                        htmlFor={technicians[tech].id}
                        key={technicians[tech].id}
                        className={cx({
                          unavailable: !technicians[tech].available
                        })}
                      >
                        <input
                          type="checkbox"
                          value={technicians[tech].id}
                          id={technicians[tech].id}
                          checked={
                            technicianIds.value &&
                            technicianIds.value.indexOf(technicians[tech].id) >=
                              0
                          }
                          onChange={collectionChangeHandler(technicianIds)}
                        />
                        <span className="indicator" />
                        {technicians[tech].name}
                        {!technicians[tech].available && ' (already scheduled)'}
                      </label>
                    );
                  })}
                </ReactCSSTransitionGroup>
              </CheckboxGroup>
            </ModalFormRow>
          )}
          <ModalFormRow>
            <ModalFormBlock>
              <label htmlFor="notes">notes</label>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%'
                }}
              >
                <textarea
                  style={{
                    fontStyle:
                      description && description.value.length > 30
                        ? 'italic'
                        : 'normal'
                  }}
                  placeholder="Notes text"
                  {...description}
                />
                {description && description.value.length > 30 && (
                  <div style={{ fontSize: 'small' }}>
                    Please try to keep notes short
                  </div>
                )}
              </div>
            </ModalFormBlock>
          </ModalFormRow>

          {this.state.canShowInputted && (
            <ModalFormRow>
              <ModalFormBlock>
                <InlineCheckbox>
                  <label htmlFor="showInputted">
                    <input
                      type="checkbox"
                      id="showInputted"
                      {...showInputted}
                    />
                    <span className="indicator" />
                    Show Inputted
                  </label>
                </InlineCheckbox>
              </ModalFormBlock>
            </ModalFormRow>
          )}

          {showAutoRenew && (
            <div>
              <ModalFormRow>
                <ModalFormBlock>
                  <InlineCheckbox>
                    <label htmlFor="autoRenew">
                      <input type="checkbox" id="autoRenew" {...autoRenew} />
                      <span className="indicator" />
                      auto renew
                    </label>
                  </InlineCheckbox>
                </ModalFormBlock>
              </ModalFormRow>
              <ModalFormRow>
                <ModalFormBlock>
                  <label>&nbsp;</label>
                  <select {...autoRenewInterval} disabled={!autoRenew.value}>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                  </select>
                </ModalFormBlock>

                <ModalFormBlock>
                  <DatePicker
                    {...autoRenewEndDate}
                    disabled={!autoRenew.value}
                    minDate={moment().add(1, 'day')}
                    placeholderText="End date"
                  />
                </ModalFormBlock>
              </ModalFormRow>
            </div>
          )}
         <ModalFormRow>
            <ModalFormBlock>
              <p
                className={cx({
                  centered: true,
                  error: true,
                  hidden: !error || submitting
                })}
              >
                {error && error.detail}
              </p>
            </ModalFormBlock>
          </ModalFormRow>
          <ModalFormRow>
            <ModalFormBlock submitButton>
              <button type="submit" disabled={submitting}>
                {submitButtonText || 'Submit'}
              </button>
            </ModalFormBlock>
          </ModalFormRow>
        </ModalForm>
      </BaseModal>
    );
  }
}

export default reduxForm({
  form: 'addEditWorkOrder',
  ...generateValidation(validations)
})(WorkOrdersCreateEdit);



// WEBPACK FOOTER //
// ./src/components/work-orders/work-orders-create-edit.js